import css from "csstype";

const table: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  width: "fit-content",
  minWidth: "91vw",
};
const employeTable: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  minWidth: "45.5vw",
  marginBottom: "1rem"
};
const tableHeader: css.Properties = {
  padding: "0.5rem 0.5rem",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  width: "100%",
};
const tableTxt: css.Properties = {
  width: "100%",
  margin: "1rem 0",
};
const tableHeadTxt: css.Properties = {
  margin: "1rem 2rem 1rem 0",
};
const employeeTableHead: css.Properties = {
  width: "100%",
  margin: "1rem 0",
};
const addEmployeeBtn: css.Properties = {
  marginRight: "1rem",
};
const tableContainer: css.Properties = {
  border: "1px solid rgb(227, 227, 227)",
  margin: "0 0 1rem 0",
  width: "93vw",
}
const buttonBack: css.Properties = {
  width: "3rem",
  height: "2rem",
  marginBottom: "0.5rem"
}

const resourceAllocationButtonBack: css.Properties = {
  width: "auto",
  minWidth: "fit-content",
  height: "2rem",
  marginBottom: "0.5rem",
  paddingLeft: "0.75rem",
  paddingRight: "0.75rem",
}
const tableFilterContainer: css.Properties = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  margin: ".5rem 0 .5rem 0"
}
const tableFilter: css.Properties = {
  width: "12rem",
  flexShrink: 0,
}
const tableFilterYear: css.Properties = {
  width: "5.25rem",
  flexShrink: 0,
}
const tableWithFiltersHeader: css.Properties = {
  padding: "0 0.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
  minWidth: 0,
};
const expectedHoursToolbarRow: css.Properties = {
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: "0.5rem",
  margin: ".5rem 0 .5rem 0",
  width: "100%",
  minWidth: 0,
  overflowX: "auto",
};
const filtersContainer: css.Properties = {
  display: "flex",
  gap: "1rem",
  alignItems: "end",
  margin: "0",
  flexWrap: "wrap"
};
const filterButton: css.Properties = {
  height: "2rem"
};
const tableHeaderWrapper: css.Properties = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between"
};
const assignmentsTableHeader: css.Properties = {
  padding: "0.5rem 0.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  maxWidth: "100%",
}
const addAssignmentButton: css.Properties = {
  maxHeight: "2rem",
  alignSelf: "center"
}
const employeesCard: css.Properties = {
  marginBottom: "2rem"
}
const hiddenFileInput: css.Properties = {
  display: "none",
};
const absentifyUpdateAction: css.Properties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  flexShrink: 0,
};
const lastUpdatedAbsentifyImportText: css.Properties = {
  marginTop: "8px",
  fontSize: "14px",
};

const statusHeaderCell: css.Properties = {
  width: "260px",
  minWidth: "200px",
  maxWidth: "320px",
};

const actionsHeaderCell: css.Properties = {
  width: "56px",
  minWidth: "56px",
  maxWidth: "72px",
  textAlign: "center",
};

const headerTooltipLabel: css.Properties = {
  position: "relative",
  display: "inline-block",
  maxWidth: "100%",
  paddingRight: "20px",
  lineHeight: 1.2,
};

const headerTooltipText: css.Properties = {
  display: "inline",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

const headerTooltipIcon: css.Properties = {
  position: "absolute",
  top: "0",
  right: "0",
  zIndex: 1,
  cursor: "help",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "14px",
  height: "14px",
  minWidth: "14px",
  minHeight: "14px",
  maxWidth: "14px",
  maxHeight: "14px",
  flexShrink: 0,
  borderRadius: "50%",
  border: "1px solid #605e5c",
  color: "#605e5c",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: 1,
  boxSizing: "border-box",
};

const inlineTooltipIcon: css.Properties = {
  cursor: "help",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "14px",
  height: "14px",
  minWidth: "14px",
  minHeight: "14px",
  maxWidth: "14px",
  maxHeight: "14px",
  flexShrink: 0,
  borderRadius: "50%",
  border: "1px solid #605e5c",
  color: "#605e5c",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: 1,
  boxSizing: "border-box",
};

const resourceAllocationToolbarRow: css.Properties = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "flex-end",
  gap: "0.75rem",
  margin: ".5rem 0 1rem 0",
  width: "100%",
};

const resourceAllocationToolbarActions: css.Properties = {
  marginLeft: "auto",
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  flexShrink: 0,
};

const toolbarReadOnlyGroup: css.Properties = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  flexShrink: 0,
};

const toolbarReadOnlyValue: css.Properties = {
  backgroundColor: "#f5f5f5",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  padding: "4px 10px",
  minHeight: "32px",
  lineHeight: "24px",
  fontSize: "14px",
  boxSizing: "border-box",
  color: "#424242",
};

const toolbarReadOnlyValueMonth: css.Properties = {
  ...toolbarReadOnlyValue,
  width: "12rem",
};

const toolbarReadOnlyValueYear: css.Properties = {
  ...toolbarReadOnlyValue,
  width: "5.25rem",
};

const toolbarFilterGroup: css.Properties = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  flexShrink: 0,
};

const readOnlyInfoBanner: css.Properties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  width: "100%",
  boxSizing: "border-box",
  alignSelf: "stretch",
  padding: "10px 14px",
  marginTop: "0",
  marginBottom: "12px",
  borderRadius: "4px",
  border: "1px solid #c7dff4",
  backgroundColor: "#f0f6fc",
  color: "#242424",
  fontSize: "14px",
  lineHeight: "20px",
};

const readOnlyInfoBannerIcon: css.Properties = {
  flexShrink: 0,
  marginTop: "2px",
};

const readOnlyInfoBannerText: css.Properties = {
  flex: "1 1 auto",
  minWidth: 0,
  whiteSpace: "normal",
  wordBreak: "break-word",
};

const dialogInfoText: css.Properties = {
  fontSize: "14px",
  lineHeight: "20px",
  color: "#424242",
  margin: "0 0 4px 0",
};

const dialogFieldHint: css.Properties = {
  color: "#616161",
  fontSize: "12px",
  marginTop: "4px",
  lineHeight: "16px",
};

const resourceAllocationPageContainer: css.Properties = {
  width: "93vw",
  maxWidth: "93vw",
  alignSelf: "flex-start",
  marginLeft: "3.5%",
};

const dialogFormField: css.Properties = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const styles = {
  table,
  tableHeader,
  tableTxt,
  addEmployeeBtn,
  tableHeadTxt,
  tableWithFiltersHeader,
  expectedHoursToolbarRow,
  employeTable,
  employeeTableHead,
  tableContainer,
  buttonBack,
  resourceAllocationButtonBack,
  tableFilterContainer,
  tableFilter,
  tableFilterYear,
  filtersContainer,
  filterButton,
  tableHeaderWrapper,
  assignmentsTableHeader,
  addAssignmentButton,
  employeesCard,
  hiddenFileInput,
  absentifyUpdateAction,
  lastUpdatedAbsentifyImportText,
  statusHeaderCell,
  actionsHeaderCell,
  headerTooltipLabel,
  headerTooltipText,
  headerTooltipIcon,
  inlineTooltipIcon,
  resourceAllocationToolbarRow,
  resourceAllocationToolbarActions,
  toolbarReadOnlyGroup,
  toolbarReadOnlyValue,
  toolbarReadOnlyValueMonth,
  toolbarReadOnlyValueYear,
  toolbarFilterGroup,
  readOnlyInfoBanner,
  readOnlyInfoBannerIcon,
  readOnlyInfoBannerText,
  dialogInfoText,
  dialogFieldHint,
  resourceAllocationPageContainer,
  dialogFormField,
};

export default styles;
